export const DiffError = ({ message }: { message: string }) => {
  return (
    <div className="rounded-md bg-error-secondary px-4 py-2 text-sm">
      {message}
    </div>
  );
};
